<template>
  <section
    key="payment-done"
    class="c-payment c-payment--done c-form c-form--ghost bg-white"
  >
    <div v-if="!price.isDisabled" class="c-payment__title p-3 p-lg-4">
      <img class="c-check" src="@/assets/images/icons/checkout/check.svg" alt="Check">
      <h3 class="fs-21 w-bold white mb-3">
        {{
          (paymentMethod == 'cash')
            ? '¡Hemos generado tu orden de pago!' : '¡Activa tu compra en Arcux!'
        }}
      </h3>

      <p v-if="paymentMethod == 'cash'" class="mb-0 white w-sbold">
        Revisa tu correo
        <span class="c-email">
          {{(
            (this.userData && this.userData.id))
              ? this.userData.email : user.email.value
          }}
        </span>
        para conocer las indicaciones de pago.
      </p>
      <p v-else class="mb-0 white w-sbold">
        {{($route.query.pc) ? 'Inicia sesión y/o registrate para disfrutar de tu producto.' : ''}}
      </p>
    </div>

    <transition name="fade" mode="out-in">
      <div v-if="activation.loading" key="loading-activation" class="p-3 p-lg-4">
          <div class="bg-white br--medium p-4 py-5 d-flex flex-column align-items-center">
            <b-spinner variant="primary"></b-spinner>
            <h1 class="fs-21 w-bold mt-3">Activando compra</h1>

            <div
              v-if="activation.alert"
              class="c-card-alert p-2 px-3 text-center mt-4"
              :class="`c-card-alert--${activation.alert.type}`"
            >
              {{activation.alert.message}}
            </div>
          </div>
      </div>
      <div v-else key="auth" class="p-3 p-lg-4">
        <template v-if="price.isDisabled">
          <div class="d-flex flex-column align-items-center text-center">
            <figure class="mb-4">
              <img
                class="of--contain"
                height="234"
                src="@/assets/images/lection/homework/no-completed.png" alt="">
            </figure>
            <h3 class="w-sbold fs-18 darks">
              El enlace de activación utilizado ya no esta disponible.
            </h3>
          </div>
        </template>

        <template v-else-if="$route.query.pc">
          <div class="c-card-alert c-card-alert--success p-3 mb-4">
            <span class="w-bold">Nota:</span>
            Enviamos este link activación a tu email (revisar spam)
          </div>

          <div class="mb-3">
            <h2 class="mb-4 d-flex justify-content-between align-items-end">
              <span class="darks fs-21 w-bold">
                {{(payment.type == 'anonymous') ? 'Regístrate' : 'Iniciar sesión'}}
              </span>
              <p class="fs-16 w-medium mb-0">
                <template v-if="payment.type == 'registered'">
                  ¿No tienes cuenta?
                  <button @click="payment.type = 'anonymous'" class="c-link c-link--primary">
                    Registrate
                  </button>
                </template>
                <template v-else>
                  ¿Ya tienes cuenta?
                  <button @click="payment.type = 'registered'" class="c-link c-link--primary">
                    Ingresar
                  </button>
                </template>
              </p>
            </h2>
            <div class="mb-4">
              <div class="row gx-4 gy-4">
                <div v-if="false" class="col col-12 col-md-6">
                  <button
                    @click="signOnMedia('facebook', payment.type)"
                    class="c-button c-button--facebook d-flex h-100
                      w-100 align-items-center justify-content-center mx-1"
                  >
                    <i class="icon-facebook d-flex align-items-center fs-18"></i>
                    <span class="ms-2">Facebook</span>
                  </button>
                </div>
                <div class="col col-12">
                  <button
                    @click="signOnMedia('google', payment.type)"
                    class="c-button c-button--google d-flex h-100
                      w-100 align-items-center justify-content-center mx-1"
                  >
                    <img src="@/assets/images/icons/google.svg" />
                    <span class="ms-2">Google</span>
                  </button>
                </div>
              </div>
            </div>
            <p class="c-hr-text c-hr-text--light mb-0 w-sbold dark-gray text-center mb-4">
              <span class="c-hr-text__content">
                {{
                  (payment.type == 'anonymous')
                    ? 'o regístrate con tu email'
                    : 'o inicia con tu usuario/email'
                }}
              </span>
            </p>
          </div>

          <div
            v-if="auth.error.active"
            class="c-card-alert c-card-alert--error p-3 mb-4 text-center"
            v-html="auth.error.message"
          >
          </div>

          <form
            class="row"
            @submit.prevent="payment.type === 'registered' ? login() : register()"
          >
            <template v-if="payment.type !== 'registered'">
              <div class="col col-12 col-md-6 mb-4 form-group">
                <input
                  type="text"
                  v-model="auth.firstName"
                  placeholder="Nombres completos"
                  :disabled="auth.isLoading"
                  class="c-form__input w-100"
                  required />
              </div>
              <div class="col col-12 col-md-6 mb-4 form-group">
                <input
                  type="text"
                  v-model="auth.lastName"
                  placeholder="Apellidos completos"
                  :disabled="auth.isLoading"
                  class="c-form__input w-100"
                  required />
              </div>
            </template>

            <div class="col col-12 mb-4 form-group">
              <input
                type="text"
                v-model="auth.email"
                :placeholder="payUserPlaceholder"
                :disabled="auth.isLoading"
                class="c-form__input w-100"
                required />
            </div>
            <div class="col col-12 mb-4">
              <input
                type="password"
                v-model="auth.password"
                placeholder="Contraseña"
                :disabled="auth.isLoading"
                class="c-form__input w-100"
                required />
            </div>
            <div class="col col-12">
              <button
                :disabled="auth.isLoading || !authButtonActive"
                class="c-button c-button--primary w-100"
                :class="{loading : auth.isLoading}">
                {{ payUserAuthButton }}
                <img
                  class="c-button__spinner"
                  src="@/assets/images/animations/spinner-white.png"
                  alt="loading"
                />
              </button>
            </div>
          </form>
        </template>

        <template v-else-if="$route.query.success">
          <div class="d-flex flex-column align-items-center text-center">
            <figure class="mb-4">
              <img
                class="of--contain"
                height="234"
                src="@/assets/images/profile/welcome.png" alt="">
            </figure>
            <h3 class="w-sbold fs-18 darks">
              {{
                (product.data.type === 'course')
                  ? '¡Disfruta tu nuevo curso!'
                  : '¡Disfruta tu suscripción!'
              }}
            </h3>
            <a
              href="/panel"
              class="c-button c-button--primary d-flex align-items-center medium"
            >
              Empezar ahora
              <Icon icon="carbon:arrow-right" class="ms-2 d-flex align-items-center fs-21" />
            </a>
          </div>
        </template>

        <template v-else-if="paymentMethod == 'cash'">
          <p class="text-center mb-0">
            Una vez completada la transacción recibirás un
            correo con las indicaciones para activar tu compra
          </p>
        </template>
      </div>
    </transition>
  </section>
</template>

<script>
/* eslint-disable */

import { Icon } from '@iconify/vue2';
import { saveSession } from '../../libs/auth';
import { mapState } from 'vuex';

export default {
  data() {
    return {
      arcux: { ...window.arcux },

      payment: {
        type: 'registered',
        isLoadingRegister: false,
        isLoadingLogin: false,

        purchase_code: '',
      },
      auth: {
        isLoading: false,

        firstName: '',
        lastName: '',
        email: '',
        password: '',
        error: {
          active: false,
          message: '',
        },
      },

      mixpanel: {
        activation: 'Web',
        purchase: null,
      },

      activation: {
        alert: null,
        loading: false,
      },
    }
  },
  components: {
    Icon,
  },
  computed: {
    ...mapState({
      country: (state) => state.checkout.country,
      price: (state) => state.checkout.price,
      product: (state) => state.checkout.product,
      paymentMethod: (state) => state.checkout.paymentMethod,
      coupon: (state) => state.checkout.coupon,
      userData: (state) => state.user.userData,
      userLoading: (state) => state.user.userLoading,
    }),

    productId() {
      let id = -1;

      if (this.$route.query.course_id) {
        id = this.$route.query.course_id;
      } else if (this.$route.query.bundle_id) {
        id = this.$route.query.bundle_id;
      } else if (this.$route.query.membership_id) {
        id = this.$route.query.membership_id;
      }

      return id;
    },
    payUserPlaceholder() {
      return (this.payment.type !== 'anonymous') ? 'Usuario o Correo electrónico' : 'Correo electrónico';
    },
    payUserAuthButton() {
      return this.payment.type !== 'registered'
        ? (this.payment.isLoadingRegister ? 'Registrando...' : 'Registrarse')
        : (this.payment.isLoadingLogin ? 'Iniciando sesión...' : 'Iniciar sesión');
    },
    authButtonActive() {
      if (this.payment.type == 'anonymous') {
        return (this.auth.email.length >= 3)
          && (this.auth.password.length > 3)
          && (this.auth.firstName.length)
          && (this.auth.lastName.length) ? true : false;
      } else {
        return (this.auth.email.length >= 3)
          && (this.auth.password.length > 3) ? true : false;
      }
    },

    productFinalPrice() {
      return (this.price.current && this.price.current.name)
        ? `${this.price.current.amount.currency.symbol_full}${Number(this.price.current.amount.final).toLocaleString('en')}`
        : '0.00';
    },
    productPaidPrice() {
      const coupon = (this.coupon.current) ? Number(this.coupon.current.amount) : 0;

      return (this.price.current && this.price.current.name)
        ? `${this.price.current.amount.currency.symbol_full}${(Number(this.price.current.amount.final) - coupon).toLocaleString('en')}`
        : '0.00';
    },
    isCheckoutV2() {
      return this.$route.query.vertion === 'v2';
    },
  },
  watch: {
    product() {
      this.runOrderActions();
    },
    price() {
      this.runOrderActions();
    }
  },
  mounted() {
    this.loadScripts();
    this.loadGlobalScripts();

    if (this.$route.query.pc) {
      this.initUser();

      this.payment.purchase_code = this.$route.query.pc;
    }

    if (this.$route.query?.origin === 'email') {
      this.mixpanel.activation = 'Email';
    }
  },
  methods: {
    initUser() {
      const arcuxCheckout = window.localStorage.getItem('arcux_checkout')
        ? JSON.parse(window.localStorage.getItem('arcux_checkout'))
        : false;

      if (arcuxCheckout && arcuxCheckout.user_firstname && arcuxCheckout.user_lastname) {
        this.auth.firstName = arcuxCheckout.user_firstname;
        this.auth.lastName  = arcuxCheckout.user_lastname;
      }
    },
    signOnMedia: function(social, pay) {
      const authType = (pay == 'anonymous') ? 'registro' : 'login';

      if (social === 'google') {
        this.authWithGoogle(authType);
      } else {
        this.auth.isLoading = true;

        FB.getLoginStatus((response) => {
          if (response.status == 'connected') {
            const token = response.authResponse.accessToken;

            this.handleFacebookAuth(authType, token);
          } else if(response.status == 'authorization_expired') {
            FB.login((response) => {
              if (response.authResponse) {
                const token = response.authResponse.accessToken;

                this.handleFacebookAuth(authType, token);
              } else {
                this.auth.isLoading     = false;
                this.auth.error.active  = true;
              }
            }, {scope: 'public_profile,email', auth_type: 'reauthorize'});
          } else {
            FB.login((response) => {
              if (response.authResponse) {
                this.handleFacebookAuth(authType, response.authResponse.accessToken);
              } else {
                this.auth.isLoading     = false;
                this.auth.error.active  = true;
                this.auth.error.message = 'No se ha podido completar el proceso.';
              }
            }, {scope: 'public_profile,email'});
          }
        });
      }
    },
    authWithGoogle: function(type) {
      this.auth.isLoading = true;

      if (type === 'login') {
        gapi.load('auth2', () => {
          const auth2 = gapi.auth2.init({
            client_id: this.arcux.project.social.google_app_id,
            fetch_basic_profile: true,
            scope: 'profile',
          });

          auth2.signIn().then((user) => {
            const id_token = user.getAuthResponse().id_token;
            const url      = `${this.arcux.site}/api/v1/auth/socials/google`;

            fetch(url, {
              method: 'POST',
              'headers': {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                token: id_token,
                authType: type,
                purchase_code: this.payment.purchase_code ? this.payment.purchase_code : '',
                product_id: this.productId,
              }),
            }).then(res => {
              return res.json();
            }).then(data => {
              if (!data.status) {
                throw data;
              }

              if (this.paymentMethod === 'cash') {
                this.sendSalesMetrics();
              }

              this.clearCheckout(); saveSession(data.token);

              if (this.isCheckoutV2) {
                this.activePurchase(data.meta);
              } else {
                location.href = `${ this.arcux.site }/panel`;
              }
            }).catch(err => {
              this.auth.error.active  = true;
              this.auth.error.message = err.message;
            }).finally(() => {
              this.auth.isLoading = false;
            });
          }, (err) => {
            this.auth.error.active  = true;
            this.auth.error.message = err.error == 'popup_closed_by_user'
                                        ? 'No se ha podido completar la operacion'
                                        : (err.error == 'access_denied'
                                          ? 'No se ha autorizado la operación, vuelve a intentarlo'
                                          : 'Ha ocurrido un error, intentado nuevamente en unos minutos');

            this.auth.isLoading = false;
          });
        });
      } else {
        gapi.load('auth2', () => {
          const auth2 = gapi.auth2.init({
            client_id: this.arcux.project.social.google_app_id,
            fetch_basic_profile: true,
            scope: 'profile',
          });

          auth2.signIn().then(user =>{
              const id_token = user.getAuthResponse().id_token;
              const url      = `${this.arcux.site}/api/v1/auth/socials/google`;

              fetch(url, {
                method: 'POST',
                'headers': {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  token: id_token,
                  authType: type,
                  purchase_code: this.payment.purchase_code ? this.payment.purchase_code : '',
                  product_id: this.productId,
                }),
              }).then(res => {
                return res.json();
              }).then(data => {
                if (!data.status) {
                  throw data;
                }

                if (this.paymentMethod === 'cash') {
                  this.sendSalesMetrics();
                }

                this.clearCheckout(); saveSession(data.token);

                if (this.isCheckoutV2) {
                  this.activePurchase(data.meta);
                } else {
                  location.href = `${ this.arcux.site }/panel`;
                }
              }).catch(err => {
                this.auth.error.active  = true;
                this.auth.error.message = err.message;
                this.auth.isLoading = false;
              });
            }, (err) => {
              this.auth.error.active  = true;
              this.auth.error.message = err.error == 'popup_closed_by_user'
                                          ? 'No se ha podido completar la operacion'
                                          : (err.error == 'access_denied'
                                            ? 'No se ha autorizado la operación, vuelve a intentarlo'
                                            : 'Ha ocurrido un error, intentado nuevamente en unos minutos');

              this.auth.isLoading = false;

              auth2.signOut();
            }
          );
        });
      }
    },

    handleFacebookAuth(authType, token) {
      FB.api('/me', { fields: 'id, name, first_name, last_name, email, locale' }, (userData) => {
        this.authWithFacebook(authType, {
          id: userData.id,
          email: userData.email,
          name: userData.name,
          first_name: userData.first_name,
          last_name: userData.last_name,
        }, token);
      })
    },
    authWithFacebook: function(type, token) {
      const url = `${this.arcux.site}/api/v1/auth/socials/facebook`;

      fetch(url, {
        method: 'POST',
        'headers': {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          token: token,
          authType: type,
          purchase_code: this.payment.purchase_code ? this.payment.purchase_code : '',
          product_id: this.productId,
        }),
      }).then(res => {
        return res.json();
      }).then(data => {
        if (!data.status) {
          throw data;
        }


        if (this.paymentMethod === 'cash') {
          this.sendSalesMetrics();
        }

        this.clearCheckout(); saveSession(data.token);

        if (this.isCheckoutV2) {
          this.activePurchase(data.meta);
        } else {
          location.href = `${ this.arcux.site }/panel`;
        }
      }).catch(err => {
        this.auth.error.active  = true;
        this.auth.error.message = err.message;
        this.auth.isLoading     = false;
      });
    },

    sendMetricsEvent: function(name, product, userType) {
      this.$ga.event(product, name, userType, -1);
    },
    sendSalesMetrics: function() {
      const eventAction = (this.product.type === 'course' || this.isCheckoutV2)
        ? this.product.data.title
        : this.$route.query.plan[0].toUpperCase() + this.$route.query.plan.slice(1);

      const currencyCode = this.price.current.amount.currency.symbol_full;
      const productPaidPrice = this.price.current.amount.final;
      const orderId = this.$route.params.order_id;

      this.$gtag.event('conversion', {
        'send_to'       : this.arcux.project.metrics.google_ads,
        'value'         : productPaidPrice,
        'currency'      : currencyCode,
        'transaction_id': orderId,
      });

      this.$ga.ecommerce.addTransaction({
        id: orderId,
        affiliation: 'Arcux Products Store',
        revenue: productPaidPrice,
      });

      this.$ga.ecommerce.addProduct({
        'id'       : orderId,
        'name'     : eventAction,
        'category' : this.product.type === 'course'
          ? (this.product.details?.categories[0].name || '')
          : 'Suscripcion',
        'brand'    : this.product.type === 'course'
          ? (this.product.details?.softwares[0].name || 'NO SOFTWARE')
          : 'Suscripcion',
        'price'    : productPaidPrice,
        'quantity' : 1,
      });

      this.$ga.ecommerce.addItem({
        'id'       : orderId,
        'name'     : eventAction,
        'category' : this.product.type === 'course'
          ? (this.product.details?.categories[0].name || '')
          : 'Suscripcion',
        'brand'    : this.product.type === 'course'
          ? (this.product.details?.softwares[0].name || 'NO SOFTWARE')
          : 'Suscripcion',
        'price'    : productPaidPrice,
        'quantity' : 1,
      });

      this.$ga.ecommerce.setAction('purchase', {
        'id'      : orderId,
        'revenue' : productPaidPrice,
        'coupon'  : this.product.type === 'course'
          ? this.coupon.code.value
          : '',
      });

      this.$ga.ecommerce.send();

      this.sendMetricsEvent(
        'Purchase',
        eventAction,
        (this.userData && this.userData.id) ? 'REGISTERED USER' : 'NON REGISTERED USER'
      );

      this.sendGTMPurchase(eventAction, productPaidPrice, orderId, currencyCode);

      if (typeof window.fbq === 'function') {
        window.fbq(
          'track',
          'Purchase',
          {
            content_name: eventAction,
            content_type: ((this.userData && this.userData.id) ?  'REGISTERED USER' : 'NON REGISTERED USER'),
            currency: currencyCode,
            value: productPaidPrice
          }
        );
      }
    },
    sendGTMPurchase(producName, productPaidPrice, orderId, currencyCode) {
      window.dataLayer.push({
        event: 'purchase',
        currency: currencyCode,
        transaction_id: orderId,
        value: productPaidPrice,
        items: [
          {
            item_id: this.product.data.id,
            item_name: producName,
            price: productPaidPrice,
          },
        ],
      });
    },

    isEmail: function(email) {
      var regex = /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,4}$/i;

      return regex.test(email) ? true : false;
    },
    login: function() {
      this.auth.isLoading = true;

      this.auth.active = false;
      this.auth.message = '';

      const url = `${this.arcux.site}/api/v1/auth/login/`;

      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: this.isEmail(this.auth.email) ? this.auth.email : '',
          username: this.auth.email,
          password: this.auth.password,
          product_id: this.productId,
          mixpanel: this.mixpanel,
          ...(!this.isCheckoutV2 && {purchase_code: this.payment.purchase_code ? this.payment.purchase_code : ''}),
        }),
      })
      .then(res => {
        return res.json();
      })
      .then(data => {
        if (!data.success) {
          throw data;
        }

        if (this.paymentMethod === 'cash') {
          this.sendSalesMetrics();
        }

        this.clearCheckout(); saveSession(data.token);

        if (this.isCheckoutV2) {
          this.activePurchase(data.meta);
        } else {
          location.href = `${ this.arcux.site }/panel`;
        }
      })
      .catch((err) => {
        this.auth.error.active  = true;
        this.auth.error.message = err.message;
      })
      .finally(() => {
        this.auth.isLoading = false;
      })
    },
    register: function() {
      this.auth.isLoading = true;
      this.auth.active  = false;
      this.auth.message = '';

      const url = `${this.arcux.site}/api/v1/auth/register/`;

      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          first_name: this.auth.firstName,
          last_name: this.auth.lastName,
          email: this.auth.email,
          username: this.auth.email,
          password: this.auth.password,
          product_id: this.productId,
          mixpanel: this.mixpanel,
          ...(!this.isCheckoutV2 && {purchase_code: this.payment.purchase_code ? this.payment.purchase_code : ''}),
        }),
      })
      .then(res => {
        return res.json();
      })
      .then(data => {
        if (!data.success) {
          throw data;
        }

        if (this.paymentMethod === 'cash') {
          this.sendSalesMetrics();
        }

        this.clearCheckout(); saveSession(data.token);

        if (this.isCheckoutV2) {
          this.activePurchase(data.meta);
        } else {
          location.href = `${ this.arcux.site }/panel`;
        }
      })
      .catch((err) => {
        this.auth.error.active  = true;
        this.auth.error.message = err.message;
        this.auth.isLoading = false;
      });
    },

    activePurchase(userId) {
      const url = `${process.env.VUE_APP_API_V2}/checkout/activation-links/${this.payment.purchase_code}/active`;

      this.activation.loading = true;
      this.activation.alert = null;

      fetch(url, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          user_id: userId,
        }),
      })
        .then((res) => {
          if (res.status === 200 || res.status < 300) {
            return res.json();
          }

          return res.text().then((text) => { throw new Error(text); });
        })
        .then((response) => {
          if (response.status) {
            this.activation.alert = {
              type: 'success',
              message: 'Activación exitosa 🥳 (redirgiendo a tu panel en 3..2..1)',
            };

            window.setTimeout(() => {
              window.location.href = `${ this.arcux.site }/panel`;
            }, 3000);
          }
        })
        .catch((error) => {
          const errorObject = JSON.parse(error.message);

          this.activation.alert = {
            type: 'error',
            message: errorObject.message,
          };

          window.setTimeout(() => {
            this.activation.loading = false;
          }, 5000);
        });
    },

    loadScripts() {
      let googleScript = document.createElement('script');
      let manyChatScript = document.createElement('script');
      let manyChatCDNScript = document.createElement('script');

      googleScript.setAttribute('src', 'https://apis.google.com/js/platform.js');

      manyChatScript.setAttribute('src', '//widget.manychat.com/769862579846062.js');
      manyChatCDNScript.setAttribute('src', 'https://mccdn.me/assets/js/widget.js');

      document.head.appendChild(googleScript);

      if (process.env.VUE_APP_MODE !== 'development') {
        document.head.appendChild(manyChatScript);
        document.head.appendChild(manyChatCDNScript);
      }
    },
    clearCheckout() {
      window.localStorage.removeItem('arcux_checkout');
    },

    runOrderActions() {
      if (this.product.data.id && this.price.current.name && this.$route.query?.success === 'ok') {
        this.sendSalesMetrics();
      }
    },
  },
}
</script>
